"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitOutputFieldPath = splitOutputFieldPath;
function splitOutputFieldPath(fieldId, hasField) {
    if (hasField(fieldId))
        return { key: fieldId, path: [] };
    const parts = fieldId.split('.');
    for (let head = parts.length - 1; head > 0; head--) {
        const key = parts.slice(0, head).join('.');
        if (hasField(key))
            return { key, path: parts.slice(head) };
    }
    return null;
}
